// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_mens = /** @type {(inputs: {}) => string} */ () => {
	return `Men's`
};

const el_mens = /** @type {(inputs: {}) => string} */ () => {
	return `Ανδρικά`
};

const ru_mens = /** @type {(inputs: {}) => string} */ () => {
	return `Мужская`
};

const he_mens = /** @type {(inputs: {}) => string} */ () => {
	return `גברים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mens = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mens(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("mens", locale)
	if (locale === "en") return en_mens(inputs)
	if (locale === "el") return el_mens(inputs)
	if (locale === "ru") return ru_mens(inputs)
	if (locale === "he") return he_mens(inputs)
	return "mens"
};